import { useEffect } from "react";
import { when } from "hooks/useWhen";
import { FLOODLIGHT_ARGS } from "consts/feature-config";

export const FloodlightProvider = ({ children }) => {
  const floodlightFeatureFlag = when(FLOODLIGHT_ARGS);

  useEffect(() => {
    if (floodlightFeatureFlag) {
      const initializeGTM = () => {
        if (window.getCkyConsent().categories.analytics) {
          window.dataLayer = window.dataLayer || [];

          function gtag() {
            window.dataLayer.push(arguments);
          }

          window.gtag = gtag;

          const scriptTag = document.createElement("script");
          scriptTag.async = true;
          scriptTag.src =
            "https://www.googletagmanager.com/gtag/js?id=DC-14832541";

          scriptTag.onload = () => {
            const inlineScript = document.createElement("script");
            inlineScript.innerHTML = `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'DC-14832541');
            `;
            document.head.appendChild(inlineScript);
          };

          scriptTag.onerror = () => {
            console.error("Failed to load Google Tag Manager script");
          };

          document.head.appendChild(scriptTag);
        }
      };

      if (
        typeof window.getCkyConsent === "undefined" ||
        !window.getCkyConsent()?.isUserActionCompleted
      ) {
        const interval = setInterval(() => {
          if (typeof window.getCkyConsent !== "undefined") {
            const consentData = window.getCkyConsent();
            // Check if user has completed their consent action
            if (consentData.isUserActionCompleted) {
              clearInterval(interval);
              initializeGTM();
            }
          }
        }, 200);
      } else {
        initializeGTM();
      }
    }
  }, [floodlightFeatureFlag]);

  return children;
};
